<template>
  <pdl-form-group
    v-model="townCity"
    :maxlength="25"
    name="townCity"
    :label="$t('address.townCity')"
    :error="getErrorMessage('townCity')"
    required
  />
</template>

<script>
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {mapState, mapMutations} from 'vuex';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';
export default {
  components: {PdlFormGroup},
  mixins: [TrekValidationMixin],
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  validations() {
    return {
      townCity: {
        required: this.trekValidators.requiredWithCustomMessage('address.townCity.invalid'),
        maxLength: this.trekValidators.maxLength('address.townCity', 25),
      },
    };
  },
  computed: {
    ...mapState('checkout', ['billingAddress']),
    townCity: {
      get() {
        return this.billingAddress.townCity ? this.billingAddress.townCity : this.modelValue;
      },
      set(townCity) {
        this.setTownCity(townCity);
      },
    },
    fieldName() {
      return 'townCity';
    },
  },
  methods: {
    ...mapMutations('checkout', ['setTownCity']),
  },
};
</script>
